/* eslint-disable import/no-cycle */
import _ from 'lodash';
import { handleActions } from 'redux-actions';
import { 	
	addIsChecking, 
	removeIsChecking, 
	clearIsChecking,

	addHasChecked, 
	removeHasChecked, 
	clearHasChecked,

	addHasUserData, 
	removeHasUserData, 
	clearHasUserData,

	addErrorMessages,
	removeErrorMessages,
	clearErrorMessages,
	
	clear,
} from './actions';
import { initialState } from './initialState';
import {
	selectRootSlice,

	selectMapIsChecking,
	selectMapHasChecked,
	selectMapHasUserData,
	selectMapErrorMessages,
} from './selectors';
import { ROOT_SLICE } from './constants';
import { getJobLineKey } from './util';


// ************
// PARTS
// ************

const reducerParts = {
	// eslint-disable-next-line no-unused-vars
	[clear]: () => _.cloneDeep(initialState),



	// ************
	// IS CHECKING
	// ************

	[addIsChecking]: (state, { payload: { survey } }) => {
		const key = getJobLineKey(survey);
		const isValidKey = key.split('~').filter(v => v).length === 3;
		if (!isValidKey) {
			return state;
		}

		const _map = { ...selectMapIsChecking(state) };
		_map[key] = true;

		return {
			...state,
			isChecking: _map,
		};
	},

	[removeIsChecking]: (state, { payload: { survey } }) => {
		const key = getJobLineKey(survey);
		const isValidKey = key.split('~').filter(v => v).length === 3;
		if (!isValidKey) {
			return state;
		}

		const _map = { ...selectMapIsChecking(state) };
		delete _map[key];

		return {
			...state,
			isChecking: _map,
		};
	},

	[clearIsChecking]: (state) => {
		return {
			...state,
			isChecking: {},
		};
	},



	// ************
	// HAS CHECKED
	// ************

	[addHasChecked]: (state, { payload: { survey } }) => {
		const key = getJobLineKey(survey);
		const isValidKey = key.split('~').filter(v => v).length === 3;
		if (!isValidKey) {
			return state;
		}

		const _map = { ...selectMapHasChecked(state) };
		_map[key] = true;

		return {
			...state,
			hasChecked: _map,
		};
	},

	[removeHasChecked]: (state, { payload: { survey } }) => {
		const key = getJobLineKey(survey);
		const isValidKey = key.split('~').filter(v => v).length === 3;
		if (!isValidKey) {
			return state;
		}

		const _map = { ...selectMapHasChecked(state) };
		delete _map[key];

		return {
			...state,
			hasChecked: _map,
		};
	},

	[clearHasChecked]: (state) => {
		return {
			...state,
			hasChecked: {},
		};
	},



	// ************
	// HAS USER DATA
	// ************

	[addHasUserData]: (state, { payload: { survey } }) => {
		const key = getJobLineKey(survey);
		const isValidKey = key.split('~').filter(v => v).length === 3;
		if (!isValidKey) {
			return state;
		}

		const _map = { ...selectMapHasUserData(state) };
		_map[key] = true;

		return {
			...state,
			hasUserData: _map,
		};
	},

	[removeHasUserData]: (state, { payload: { survey } }) => {
		const key = getJobLineKey(survey);
		const isValidKey = key.split('~').filter(v => v).length === 3;
		if (!isValidKey) {
			return state;
		}

		const _map = { ...selectMapHasUserData(state) };
		delete _map[key];

		return {
			...state,
			hasUserData: _map,
		};
	},

	[clearHasUserData]: (state) => {
		return {
			...state,
			hasUserData: {},
		};
	},



	// ************
	// ERROR MESSAGES
	// ************

	[addErrorMessages]: (state, { payload: { survey, message } }) => {
		const key = getJobLineKey(survey);
		const isValidKey = key.split('~').filter(v => v).length === 3;
		if (!isValidKey) {
			return state;
		}

		const _map = { ...selectMapErrorMessages(state) };
		_map[key] = message;

		return {
			...state,
			errorMessages: _map,
		};
	},

	[removeErrorMessages]: (state, { payload: { survey } }) => {
		const key = getJobLineKey(survey);
		const isValidKey = key.split('~').filter(v => v).length === 3;
		if (!isValidKey) {
			return state;
		}

		const _map = { ...selectMapErrorMessages(state) };
		delete _map[key];

		return {
			...state,
			errorMessages: _map,
		};
	},

	[clearErrorMessages]: (state) => {
		return {
			...state,
			errorMessages: {},
		};
	},
};

export default handleActions(reducerParts, initialState);
